import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class TokenService {
  private key = 'crud_jwt';

  setToken(token: string) { localStorage.setItem(this.key, token); }
  getToken(): string | null { return localStorage.getItem(this.key); }
  clear() { localStorage.removeItem(this.key); }
}
